<script lang="ts">
  import { ResponsiveVars } from '@twist/core';

  export let language: string | undefined = undefined;

  const responsiveVars = new ResponsiveVars()
    .addFluid('margin-y', [
      ['min', 16],
      ['lg', 'max', 16, 24]
    ])
    .addFluid('font-size', [
      ['min', 14],
      ['lg', 'max', 14, 16]
    ])
    .toCSS();
</script>

{#if language}
  <li class={responsiveVars}>
    {language}
    <ul>
      <slot />
    </ul>
  </li>
{:else}
  <slot />
{/if}

<style lang="scss">
  ul {
    list-style: none;
    padding: 0;
  }

  li {
    color: var(--twist-color-gray-100);
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    font-weight: 700;
    line-height: 150%;
    margin: var(--margin-y) 0;
    padding: 18px 0 0;
  }
</style>
